import React, { useEffect, useState } from 'react';
import { LockIcon, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Solutions',
    href: '#solutions'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${isScrolled ? 'bg-brand-dark/80 backdrop-blur-md border-brand-border py-4' : 'bg-transparent border-transparent py-6'}`} data-id="element-122">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-123">
        <a href="#" className="flex items-center gap-2 group" data-id="element-124">
          <div className="relative flex items-center justify-center w-10 h-10 rounded-lg bg-brand-darker border border-brand-border group-hover:border-brand-steel transition-colors" data-id="element-125">
            <LockIcon className="w-5 h-5 text-brand-steel" data-id="element-126" />
            <div className="absolute inset-0 bg-brand-steel/20 blur-md rounded-lg opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-127" />
          </div>
          <span className="font-mono font-bold text-xl tracking-tight text-white" data-id="element-128">
            EPIC<span className="text-brand-steel" data-id="element-129">DROP</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-130">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-mono text-slate-400 hover:text-brand-steel transition-colors" data-id="element-131">
              <span className="text-brand-steel/50 mr-1" data-id="element-132">/</span>
              {link.name}
            </a>)}
          <a href="#contact" className="px-5 py-2.5 bg-brand-steel hover:bg-brand-steel-light text-white font-mono text-sm font-medium rounded-md transition-all shadow-[0_0_15px_rgba(74,144,217,0.3)] hover:shadow-[0_0_25px_rgba(74,144,217,0.5)]" data-id="element-133">
            Request Audit
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-slate-300 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-134">
          {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-135" /> : <Menu className="w-6 h-6" data-id="element-136" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-137">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-brand-darker border-b border-brand-border overflow-hidden" data-id="element-138">
            <div className="container mx-auto px-6 py-4 flex flex-col gap-4" data-id="element-139">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-sm font-mono text-slate-300 hover:text-brand-steel py-2 border-b border-brand-border/50" data-id="element-140">
                  <span className="text-brand-steel/50 mr-2" data-id="element-141">&gt;</span>
                  {link.name}
                </a>)}
              <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="mt-2 text-center px-5 py-3 bg-brand-steel/10 border border-brand-steel text-brand-steel font-mono text-sm font-medium rounded-md" data-id="element-142">
                Request Audit
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}